/**
 * @generated SignedSource<<ba7351edb9838b0f5572457c714fe445>>
 * @relayHash 94b791ef3d3c0aceecb371035ffe1e7a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 49953f79e8c30781f70441ec97f4ac6939326161e67c526d5fa1faffac763801

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ApprovalsContextWorkflowStatusesQuery$variables = {
  cloudId: string;
  transitionType?: ConfluenceApprovalTransitionType | null | undefined;
};
export type ApprovalsContextWorkflowStatusesQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null | undefined;
    readonly displayProperties: {
      readonly color: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ApprovalsContextWorkflowStatusesQuery = {
  response: ApprovalsContextWorkflowStatusesQuery$data;
  variables: ApprovalsContextWorkflowStatusesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "transitionType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "transitionType",
        "variableName": "transitionType"
      }
    ],
    "concreteType": "ConfluenceApprovalsWorkflowStatus",
    "kind": "LinkedField",
    "name": "confluence_contentApprovalStatuses",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "allowsReviews"
      },
      {
        "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
        "kind": "LinkedField",
        "name": "displayProperties",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "color"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextWorkflowStatusesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextWorkflowStatusesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94b791ef3d3c0aceecb371035ffe1e7a",
    "id": "49953f79e8c30781f70441ec97f4ac6939326161e67c526d5fa1faffac763801",
    "metadata": {},
    "name": "ApprovalsContextWorkflowStatusesQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextWorkflowStatusesQuery($cloudId:ID!,$transitionType:ConfluenceApprovalTransitionType){confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}}}"
  }
};
})();

(node as any).hash = "38bfa4d9d5c2dbe190a247341235bfe5";

export default node;
